<script>
import { validationMixin } from 'vuelidate'
import { requiredIf, minLength, numeric } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import { formatter } from '@/helpers/formatter'
import pdf from 'vue-pdf'
import vueDragResize from 'vue-drag-resize'
const splitBetween = (value, vm) => {
  if (
    vm.letterCategory === 'series' &&
    vm.splitTypeSelected === vm.$enums.SplitType.ByPages
  ) {
    // is oneSided validation
    if (vm.printModeSelected === vm.$enums.PrintMode.Simplex)
      return value >= 1 && value <= (vm.hasLargeLetterPermission ? 56 : 9)
    // PrintMode validation
    if (vm.printModeSelected === vm.$enums.PrintMode.Duplex)
      return value >= 1 && value <= (vm.hasLargeLetterPermission ? 112 : 18)
  } else {
    return true
  }
}
export default {
  components: {
    pdf,
    vueDragResize
  },
  mixins: [validationMixin, formatter],
  props: {
    letterCategory: { type: String },
    showDialog: { type: Boolean },
    files: { type: Array },
    isEdit: { type: Boolean }
  },
  validations: {
    splitTypeSelected: {
      required: requiredIf(function () {
        return this.letterCategory === 'series'
      })
    },
    splitAfterNPages: {
      required: requiredIf(function () {
        return (
          this.letterCategory === 'series' &&
          this.splitTypeSelected === this.$enums.SplitType.ByPages
        )
      }),
      numeric,
      splitBetween
    },
    splitAfterTextPattern: {
      required: requiredIf(function () {
        return (
          this.letterCategory === 'series' &&
          this.splitTypeSelected === this.$enums.SplitType.ByTextPattern
        )
      }),
      minLength: minLength(1)
    }
  },
  data: vm => ({
    defaultValues: {
      splitAfterNPages: 1,
      splitAfterTextPattern: '',
      splitTypeSelected: null,
      ignoreCase: true,
      area: { left: 100, top: 100, width: 100, height: 100 }
    },
    valid: false,
    printModeSelected: null,
    colorModeSelected: null,
    foldTypeSelected: null,
    splitAfterNPages: 1,
    splitAfterTextPattern: '',
    splitTypeSelected: null,
    ignoreCase: false,
    pdfData: '',
    showFileList: true,
    area: null,
    canvasWidth: 450,
    canvasHeight: 630,
    maxHeigthInMM: 297,
    maxWidthInMM: 210,
    columns: vm.letterCategory === 'series' ? 5 : 12,
    costCenter: ''
  }),
  computed: {
    ...mapState({
      userSettings: state => state.settings
    }),
    isOneSided() {
      return this.printModeSelected === this.$enums.PrintMode.Simplex
    },
    splitAfterNPagesErrors() {
      const errors = []
      if (!this.$v.splitAfterNPages.$dirty) return errors
      if (!this.$v.splitAfterNPages.required)
        errors.push(this.$t('component.upload.uploadDialog.errorFillField'))
      if (!this.$v.splitAfterNPages.numeric)
        errors.push(this.$t('component.upload.uploadDialog.errorNumeric'))

      if (this.isOneSided && !this.$v.splitAfterNPages.splitBetween)
        errors.push(
          this.$t(
            this.$t('component.upload.uploadDialog.errorOneSidedRangeLarge') +
              (this.hasLargeLetterPermission ? 'Large' : '')
          )
        )
      if (!this.isOneSided && !this.$v.splitAfterNPages.splitBetween)
        errors.push(
          this.$t(
            this.$t('component.upload.uploadDialog.errorIsDuplexRange') +
              (this.hasLargeLetterPermission ? 'Large' : '')
          )
        )
      return errors
    },
    hasLargeLetterPermission() {
      return this.$permissions.hasLargeLetter
    },
    pageCountNotice() {
      return this.$t(
        this.hasLargeLetterPermission
          ? 'component.upload.uploadDialog.pageCountNoticeLarge'
          : 'component.upload.uploadDialog.pageCountNotice'
      )
    }
  },
  watch: {
    showDialog(newValue) {
      if (newValue) {
        this.assignDefaultValues()
        this.assignUserSettingsValues()
        var reader = new FileReader()
        var that = this
        reader.onload = function (event) {
          that.pdfData = event.target.result
        }
        reader.readAsDataURL(this.files[0])
        this.initializeDetectionArea()
      }
      if (this.showDialog && this.isEdit) {
        this.fillForm()
      }
    }
  },
  created: function () {
    // only on single-letter toggle the fileList
    // series can only select 1 file
    if (this.letterCategory === 'single') {
      this.showFileList = false
    }
    this.assignDefaultValues()
    this.assignUserSettingsValues()

  },
  methods: {
    assignDefaultValues() {
      const defaults = this.defaultValues
      this.splitAfterNPages = defaults.splitAfterNPages
      this.splitAfterTextPattern = defaults.splitAfterTextPattern
      this.splitTypeSelected = defaults.splitTypeSelected
      this.ignoreCase = defaults.ignoreCase
      this.area = defaults.area
    },
    assignUserSettingsValues() {
      this.printModeSelected =
        this.userSettings.printMode || this.$enums.PrintMode.Duplex
      this.colorModeSelected =
        this.userSettings.colorMode || this.$enums.ColorMode.Color
      this.foldTypeSelected =
        this.userSettings.foldType || this.$enums.FoldType.Size105
      this.costCenter = this.userSettings.defaultCostCenter
    },
    onResizstop: function (area) {
      this.area = area
    },
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const fileSettings = {
          splitAfterNPages: parseInt(0 + this.splitAfterNPages),
          splitAfterTextPattern: this.splitAfterTextPattern,
          SplitType: this.splitTypeSelected,
          ColorMode: this.colorModeSelected,
          PrintMode: this.printModeSelected,
          FoldType: this.foldTypeSelected,
          ignoreCase: this.ignoreCase,
          detectionArea: this.pixelToMM(this.area),
          CostCenter: this.costCenter
        }
        this.$emit('submit', fileSettings)
      }
    },
    fillForm: function () {
      // fills the fields when in edit-mode
      const file = this.files[0]
      this.printModeSelected = file.PrintMode
      this.colorModeSelected = file.ColorMode
      this.foldTypeSelected = file.FoldType
      this.splitAfterNPages = file.splitAfterNPages
      this.splitAfterTextPattern = file.splitAfterTextPattern
      this.splitTypeSelected = file.SplitType
      this.ignoreCase = file.ignoreCase
      this.area = this.mmToPixel({
        x: file.detectionArea.positionX,
        y: file.detectionArea.positionY,
        width: file.detectionArea.width,
        height: file.detectionArea.height
      })
      this.costCenter = file.CostCenter
    },
    initializeDetectionArea() {
      this.area = this.mmToPixel({
        x: 185,
        y: 645,
        width: 730,
        height: 238
      })
    },
    pixelToMM(area) {
      let x = (area.left * this.maxWidthInMM * 10) / this.canvasWidth
      let y = (area.top * this.maxHeigthInMM * 10) / this.canvasHeight
      let width = (area.width * this.maxWidthInMM * 10) / this.canvasWidth
      let height = (area.height * this.maxHeigthInMM * 10) / this.canvasHeight
      return {
        positionX: Math.floor(x),
        positionY: Math.floor(y),
        width: Math.floor(width),
        height: Math.floor(height)
      }
    },
    mmToPixel(area) {
      return {
        left: (area.x * this.canvasWidth) / (10 * this.maxWidthInMM),
        top: (area.y * this.canvasHeight) / (10 * this.maxHeigthInMM),
        width: (area.width * this.canvasWidth) / (10 * this.maxWidthInMM),
        height: (area.height * this.canvasHeight) / (10 * this.maxHeigthInMM)
      }
    },
    deleteFiles() {
      if (!this.isEdit) {
        let uploadFileIds = this.files.reduce((acc, value) => {
          acc.push(value.id)
          return acc
        }, [])
        if (uploadFileIds) {
          this.$uploadService.deleteFile({ uploadFileIds: uploadFileIds })
        }
      }
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
<template>
  <v-dialog
    v-model="showDialog"
    :width="letterCategory === 'single' ? 500 : 900"
    persistent="">
    <v-form :id="letterCategory + 'UploadDialog'" ref="form" v-model="valid">
      <v-card>
        <DialogBaseColoredTitle>
          <v-row>
            <v-col> {{ $t('component.upload.uploadDialog.header') }} </v-col>
          </v-row>
        </DialogBaseColoredTitle>
        <v-divider></v-divider>
        <v-container>
          <v-row :style="$vuetify.breakpoint.xsOnly ? 'overflow:scroll;' : ''">
            <v-col
              v-if="letterCategory == 'series'"
              cols="6"
              class="ma-0 dragParent"
              :style="{
                maxWidth: canvasWidth + 'px',
                height: canvasHeight + 'px',
                flexBasis: canvasWidth + 'px'
              }">
              <vueDragResize
                v-if="splitTypeSelected === $enums.SplitType.ByTextPattern"
                id="draggable-container"
                :parent-limitation="true"
                :prevent-active-behavior="true"
                :is-active="true"
                :w="area.width"
                :h="area.height"
                :z="999"
                :x="area.left"
                :y="area.top"
                @resizestop="onResizstop"
                @dragstop="onResizstop">
              </vueDragResize>
              <pdf :src="pdfData" :page="1"></pdf>
            </v-col>
            <v-divider
              v-if="letterCategory == 'series' && $vuetify.breakpoint.mdAndUp"
              class="mx-4"
              vertical
            ></v-divider>
            <v-col cols="12" :md="columns">
              <v-card-text class="pt-5 pb-1 pl-2 ml-0">
                <v-row v-if="letterCategory === 'single'" class="px-1">
                  <v-col class="pt-0 pb-0">
                    <a @click="showFileList = !showFileList"
                    ><span v-if="!showFileList"
                    >{{ $t('component.upload.uploadDialog.showFileList')
                      }}<v-icon class="pb-1" color="primary"
                      >mdi-menu-down</v-icon
                      ></span
                    >
                      <span v-else
                      >{{ $t('component.upload.uploadDialog.closeFileList')
                        }}<v-icon class="pb-1" color="primary"
                        >mdi-menu-up</v-icon
                        >
                      </span></a
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-0">
                    <v-expand-transition>
                      <div
                        v-if="showFileList"
                        style="max-height: 138px"
                        class="overflow-y-auto">
                        <div v-for="file in files" :key="file.name">
                          <v-row class="ml-1 mr-1">
                            <v-col
                              cols="8"
                              class="pt-1 pr-1 pb-0 pl-0 text-truncate">
                              {{ file.name }}
                            </v-col>
                            <v-col class="pt-1 pr-0 pb-0 pl-1" align="right">
                              {{ formatBytes(file.size, 2) }}
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                        </div>
                      </div>
                    </v-expand-transition>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    {{ $t('component.upload.uploadDialog.documentCompletion') }}
                  </v-col>
                </v-row>
                <v-row v-if="!userSettings.locked">
                  <v-col>
                    <v-radio-group
                      v-model="printModeSelected"
                      row
                      hide-details
                      class="pa-0 ma-0">
                      <v-radio
                        :id="letterCategory + 'isOneSided'"
                        name="PrintMode"
                        :label="$t('component.upload.uploadDialog.oneSidedPrint')"
                        :value="$enums.PrintMode.Simplex"
                      ></v-radio>
                      <v-radio
                        :id="letterCategory + 'isDoubleSided'"
                        name="PrintMode"
                        :label="$t('component.upload.uploadDialog.doubleSidedPrint')"
                        :value="$enums.PrintMode.Duplex"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row
                  v-if="$permissions.hasBlackAndWhite && !userSettings.locked">
                  <v-col class="pt-0 pb-0">
                    <v-radio-group
                      v-model="colorModeSelected"
                      row
                      hide-details
                      class="pa-0 ma-0">
                      <v-radio
                        :id="letterCategory + 'Color'"
                        class="mr-8"
                        name="ColorMode"
                        :label="$t('component.upload.uploadDialog.colored')"
                        :value="$enums.ColorMode.Color"
                      ></v-radio>
                      <v-radio
                        :id="letterCategory + 'Sw'"
                        name="ColorMode"
                        :label="$t('component.upload.uploadDialog.blackAndWhite')"
                        :value="$enums.ColorMode.Sw"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="$permissions.hasFoldType && !userSettings.locked">
                  <v-col class="pb-0">
                    <v-radio-group
                      v-model="foldTypeSelected"
                      row
                      hide-details
                      class="pa-0 ma-0">
                      <v-radio
                        :id="letterCategory + 'size105'"
                        class="mr-8"
                        name="FoldType"
                        :label="$t('component.upload.uploadDialog.size105')"
                        :value="$enums.FoldType.Size105"
                      ></v-radio>
                      <v-radio
                        :id="letterCategory + 'size87'"
                        name="FoldType"
                        :label="$t('component.upload.uploadDialog.size87')"
                        :value="$enums.FoldType.Size87"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row
                  v-if="$permissions.hasCostCenter && !userSettings.locked"
                  class="mb-0">
                  <v-col>
                    <v-text-field
                      id="upload-dialog-cost-center"
                      v-model="costCenter"
                      :label="$t('component.upload.uploadDialog.costCenter')"
                      outlined
                      hide-details
                      maxlength="99"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="letterCategory == 'single'">
                  <v-col>
                    {{ pageCountNotice }}
                  </v-col>
                </v-row>
                <v-divider v-if="letterCategory != 'single'"></v-divider>
                <v-radio-group
                  v-if="letterCategory != 'single'"
                  v-model="splitTypeSelected"
                  class="mt-0"
                >
                  <v-row>
                    <v-col cols="12" sm="7" md="12">
                      <v-radio
                        id="splitByPages"
                        name="splitType"
                        :value="$enums.SplitType.ByPages"
                      ><template #label>
                        {{ $t('component.upload.uploadDialog.dividerPages') }}
                        <v-tooltip top max-width="180px">
                          <template #activator="{ on }">
                            <v-icon class="pl-2" color="primary" v-on="on"
                            >mdi-alert-circle-outline</v-icon>
                          </template>
                          <span>{{ $t('component.upload.uploadDialog.infoPages') }}</span>
                        </v-tooltip>
                      </template>
                      </v-radio>
                      <v-text-field
                        v-if="
                          letterCategory == 'series' &&
                          splitTypeSelected == $enums.SplitType.ByPages"
                        :id="letterCategory + 'SplitAfterNPages'"
                        v-model.number="splitAfterNPages"
                        outlined
                        type="number"
                        min="1"
                        required
                        :error-messages="splitAfterNPagesErrors"
                        @input="$v.splitAfterNPages.$touch()"
                        @blur="$v.splitAfterNPages.$touch()">
                        <template #prepend>
                          <v-btn icon>
                            <v-icon
                              color="red"
                              @click="
                                if (splitAfterNPages > 1) splitAfterNPages-- ">
                              mdi-minus
                            </v-icon>
                          </v-btn>
                        </template>
                        <template #append-outer>
                          <v-btn icon>
                            <v-icon color="green" @click="splitAfterNPages++">
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row>
                    <v-col cols="12">
                      <v-radio
                        id="splitByTextPattern"
                        name="splitType"
                        :value="$enums.SplitType.ByTextPattern">
                        <template #label>
                          {{ $t('component.upload.uploadDialog.dividerRegex') }}
                          <v-tooltip top max-width="180px">
                            <template #activator="{ on }">
                              <v-icon class="pl-2" color="primary" v-on="on"
                              >mdi-alert-circle-outline</v-icon>
                            </template>
                            <span>{{ $t('component.upload.uploadDialog.infoRegex') }}</span>
                          </v-tooltip>
                        </template>
                      </v-radio>
                      <v-text-field
                        v-if="
                          letterCategory == 'series' &&
                          splitTypeSelected == $enums.SplitType.ByTextPattern"
                        :id="letterCategory + 'SplitAfterTextPattern'"
                        v-model="splitAfterTextPattern"
                        outlined
                        :label="$t('component.upload.uploadDialog.searchText')"
                        required
                        @input="$v.splitAfterTextPattern.$touch()"
                        @blur="$v.splitAfterTextPattern.$touch()"
                      ></v-text-field>
                      <v-checkbox
                        v-if="
                          letterCategory == 'series' &&
                          splitTypeSelected == $enums.SplitType.ByTextPattern"
                        :id="letterCategory + 'ignoreCase'"
                        v-model="ignoreCase"
                        :label="$t('component.upload.uploadDialog.ignoreCase')">
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-card-text>
              <v-divider class="py-1"></v-divider>
              <DialogBaseActions>
                <v-row>
                  <v-col align="center">
                    <v-btn
                      :id="letterCategory + 'CancelUpload'"
                      color="secondary"
                      @click.stop="deleteFiles"
                    >{{ $t('button.cancel') }}</v-btn
                    >
                  </v-col>
                  <v-col align="center">
                    <v-btn
                      :id="letterCategory + 'SubmitUpload'"
                      :disabled="$v.$invalid"
                      color="primary"
                      @click.stop="submit()"
                    >{{ $t('button.take.over') }}</v-btn>
                  </v-col>
                </v-row>
              </DialogBaseActions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style>
#seriesSplitAfterNPages {
  text-align: center !important;
}
/* Hide Arrows */
/* Chrome, Safari, Edge, Opera */
input[id='seriesSplitAfterNPages']::-webkit-outer-spin-button,
input[id='seriesSplitAfterNPages']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[id='seriesSplitAfterNPages'] {
  appearance: textfield;
}

.file-name {
  text-overflow: ellipsis;
}
#draggable-container {
  background-color: rgba(0, 255, 0, 0.2);
}
.dragParent {
  position: relative;
  box-sizing: border-box;
}
#seriesUploadDialog .v-messages,
#seriesUploadDialog .v-text-field__details {
  min-height: 0px;
}
.v-input--radio-group .v-input__control {
  width: 100% !important;
}
</style>
